import { useRef } from 'react';

/**
 * The same array while every row in it is the same object. A paged read rebuilds its rows array on
 * renders that change no row; a new array resets the grid's rows, which aborts an export in flight
 * ("The grid changed while the export was being prepared"). Business Setup grids pass rows through it.
 */
export function useStableRows<Rows extends readonly unknown[]>(rows: Rows): Rows {
  const shown = useRef(rows);
  const unchanged = rows.length === shown.current.length && rows.every((row, index) => row === shown.current[index]);
  if (!unchanged) shown.current = rows;
  return shown.current;
}
